import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from './../../core/services/translation.service';

/**
 * 
 * 
 * @author Giulio Montagner
 * @version 1.0.0
 * @since 26th February 2018
 * @export
 * @class TranslatePipe
 * @implements {PipeTransform}
 */
@Pipe({ name: 'translate' })
export class TranslatePipe implements PipeTransform {

    /**
     * Creates an instance of TranslatePipe.
     * @author Giulio Montagner
     * @param {TranslationService} translationService 
     * @memberof TranslatePipe
     */
    constructor(private translationService: TranslationService){
       // Do nothing 
    }

    /**
     * 
     * 
     * @author Giulio Montagner
     * @param {string} value 
     * @param {string} [source='generic'] 
     * @returns 
     * @memberof TranslatePipe
     */
    transform(value: string, source: string = 'generic') {
        if (value) {
            return this.translationService.getMessageTranslation(value, source);
        }

        return value;
    }

}